import Nav from "react-bootstrap/Nav";
import { useContext, useEffect, useState } from "react";
import img1 from "../assets/img1.png";
import img8 from "../assets/img8.png";
import Loading from "../GelobalComponents/Loading";
import { AppStateContext } from "../Context/contextState";
import "./projectsPage.css";
import { useNavigate } from "react-router-dom";
import CreateProject from "../GelobalComponents/ModalCreateProject";
import RemoveBox from "../GelobalComponents/ModalRemove";
import Toasts from "../GelobalComponents/Toasts";

export default function ProjectsPage() {
  const [project, setProject] = useState([]);
  const { loading,setLoading, setProjectId, setProjectTitle } =
    useContext(AppStateContext);

  const [toastsShow, setToastsShow] = useState(false);
  const [toastsShowBack, setToastsShowBack] = useState(false);
  const [toastsText, setToastsText] = useState();
  const [height1 , setHeight1] = useState(window.innerHeight);

  const navigate = useNavigate();
  const handleResize = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    setHeight1(height);
    console.log(`Resized to Width: ${width}, Height: ${height}`);
  };

  const fetchProjects = async () => {
    try {
      const response = await fetch(
       
        "https://3dbuilding.parisashahbazi.com/api/projects",
        // "https://api.ifc.mirzaeei.com/api/projects",
        // "https://api.mirzaeei.com/api/projects",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      const data = await response.json();
      setProject(data?.info.data);
      setLoading(false);
    } catch (err) {
      console.error("Error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const savedProjectId = localStorage.getItem("projectId");
    const savedProjectTitle = localStorage.getItem("projectTitle");
    if (savedProjectId) {
      setProjectId(savedProjectId);
      setProjectTitle(savedProjectTitle);
    }
    fetchProjects();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("token");
    setLoading(false);
    navigate("/");
  };

  const handleLoginProject = (itemId, title) => {
    setProjectId(itemId);
    setProjectTitle(title);
    localStorage.setItem("projectId", itemId);
    localStorage.setItem("projectTitle", title);
    navigate(`/projects/${itemId}`);
  };

  let height2 = height1 * 0.84 ;

  return (
    <>
      <header className="Header-page">
        <div className="container">
          <div className="Header-container">
            <div className="Header-content">
              <div className="Header-logo">
                <img src={img1} alt="" />
              </div>
              <div className="Header-title">
                <h3>پروژه ها</h3>
              </div>
            </div>
            <div className="Exit-btn">
              <button type="button" onClick={handleLogout}>
                خروج
              </button>
            </div>
          </div>
        </div>
      </header>
      <div className="main">
        <div className="Projects-page">
          <div className="container">
            <div className="heading">
              <div className="BreadcrumbPage">
                <Nav
                  variant="underline"
                  defaultActiveKey="/projectsPage"
                  as="ul"
                >
                  <Nav.Item as="li">
                    <Nav.Link
                      href="/projectsPage"
                      className="BreadcrumbPage-title"
                    >
                      همه
                    </Nav.Link>
                  </Nav.Item>
                </Nav>
              </div>
              <div className="create-project">
                <CreateProject
                  fetchProjects={fetchProjects}
                  ToastsShow={setToastsShow}
                  ToastsText={setToastsText}
                  ToastsShowBack={setToastsShowBack}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="Projects-content">
          <div className="container" style={{height : `${height2}px`}}>
            <div className="row Projects-card-group">
              {project.map((item, key) => {
                return (
                  <div
                    key={item.id}
                    class="card Card col-xl-3 col-lg-4 col-sm-6 col-12"
                  >
                    <div className="Card-container">
                      <div className="Card-image-container">
                        <div>
                          <img
                            src={img8}
                            alt=""
                            className="card-img-top Card-image"
                          />
                        </div>
                      </div>
                      <div className="card-body Card-body">
                        <h5 className="card-title Card-title">{item.title}</h5>
                        <p className="card-text Card-text">
                          {item.description}
                        </p>
                        <div className="Card-Buttons">
                          <button
                            type="button"
                            className="btn btn-primary Card-btn"
                            onClick={async () => {
                              handleLoginProject(item.id, item.title);
                              await setLoading(true);
                            }}
                          >
                            مشاهده پروژه
                          </button>
                          <RemoveBox
                            itemId={item.id}
                            projects={project}
                            funProjects={setProject}
                            setLoading={setLoading}
                            fetchProjects={fetchProjects}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
      {loading && <Loading />}
      <Toasts
        toastsShow={toastsShow}
        toastsText={toastsText}
        toastsShowBack={toastsShowBack}
      />
    </>
  );
}
